import React, { useState } from "react";
import {
  BaseButtons,
  TextInputFieldSearch,
} from "../../../../../components/atoms";
import { BlackAndWhite } from "../../../../../themes/Colors";
import PractionerHeader from "../practioner-header/PractionerHeader";
import { PrescriptionDisplay } from "../../../../doc-portal/components";

const PractionerTab = () => {
  const [displaySelected, setDisplaySelected] = useState("practioners");
  const [search, setSearch] = useState("");
  const [displayTab, setDisplayTab] = useState("prescriptions");

  const [filter, setFilter] = useState("requested");

  const [filterCheck, setFilterCheck] = useState("prescription");

  const [prescriptionArray, setPrescriptionArray] = useState(null);
  const [section21Array, setSection21Array] = useState(null);

  // get PrescriptionDisplay only approved and the requested

  // get section 21 aplications requests and the completes

  // get doctor info

  // get practice info

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        backgroundColor: BlackAndWhite.secondary,
        justifyContent: "flex-start",
        alignItems: "center",
      }}
    >
      <div
        style={{
          minHeight: 60,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          width: "100%",
        }}
      >
        <div style={{ marginLeft: 0, marginRight: 10, width: 370 }}>
          <div
            style={{
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginRight: 150,
              width: 370,

              borderWidth: 0.5,
            }}
          >
            <TextInputFieldSearch
              placeholder={"Type here to search"}
              height={50}
              borderRadius={1}
              onChange={(e) => setSearch(e.target.value)}
              value={search}
              mini={true}
            />
            <div
              style={{
                height: 56,
                minWidth: 120,
                backgroundColor: BlackAndWhite.primary,
                borderRadius: 0,
                display: "flex",
                color: BlackAndWhite.secondary,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                onClick={() => setSearch("")}
                style={{ fontSize: 12, fontWeight: "bold" }}
              >
                CLEAR
              </div>
            </div>
          </div>
        </div>{" "}
        <div style={{ flex: 1 }} />
        {/* <BaseButtons
          label={"INVITES"}
          mini={true}
          marginTopFalse={true}
          invert={displaySelected === "invites" ? false : true}
          onClick={() => setDisplaySelected("invites")}
        /> */}
        {filterCheck === "prescriptions" ? (
          <div
            style={{
              width: 300,
              // backgroundColor: BlackAndWhite.red,
              minHeight: 50,
              borderTopLeftRadius: 4,
              display: "flex",
              alignItems: "center",
              maxHeight: 50,
              height: 50,
              overflow: "hidden",
              justifyContent: "space-evenly",
              marginRight: 5,
            }}
          >
            {/* <BaseButtons
                mini={true}
                label={"PATIENTS"}
                marginTopFalse={true}
                size={"32.5%"}
                invert={displayTab === "patients" ? false : true}
                onClick={() => setDisplayTab("patients")}
                height={displayTab === "patients" ? "88%" : "88%"}
                // backgroundColor={BlackAndWhite.red}
              /> */}
            <BaseButtons
              mini={true}
              label={"APPROVED"}
              marginTopFalse={true}
              size={"49%"}
              invert={filter === "approved" ? false : true}
              onClick={() => setFilter("approved")}
              height={filter === "approved" ? "70%" : "70%"}
              marginRight={5}
              // backgroundColor={BlackAndWhite.red}
            />
            <BaseButtons
              mini={true}
              label={"REQUESTED"}
              marginTopFalse={true}
              size={"49%"}
              invert={filter === "requested" ? false : true}
              onClick={() => setFilter("requested")}
              height={filter === "requested" ? "70%" : "70%"}
              // backgroundColor={BlackAndWhite.red}
            />
          </div>
        ) : null}
        {filterCheck === "section21" ? (
          <div
            style={{
              width: 300,
              // backgroundColor: BlackAndWhite.red,
              minHeight: 50,
              borderTopLeftRadius: 4,
              display: "flex",
              alignItems: "center",
              maxHeight: 50,
              height: 50,
              overflow: "hidden",
              justifyContent: "space-evenly",
              marginRight: 5,
            }}
          >
            {/* <BaseButtons
                mini={true}
                label={"PATIENTS"}
                marginTopFalse={true}
                size={"32.5%"}
                invert={displayTab === "patients" ? false : true}
                onClick={() => setDisplayTab("patients")}
                height={displayTab === "patients" ? "88%" : "88%"}
                // backgroundColor={BlackAndWhite.red}
              /> */}
            <BaseButtons
              mini={true}
              label={"APPROVED"}
              marginTopFalse={true}
              size={"49%"}
              invert={filter === "approved" ? false : true}
              onClick={() => setFilter("approved")}
              height={filter === "approved" ? "70%" : "70%"}
              marginRight={5}
              // backgroundColor={BlackAndWhite.red}
            />
            <BaseButtons
              mini={true}
              label={"PENDING"}
              marginTopFalse={true}
              size={"49%"}
              invert={filter === "pending" ? false : true}
              onClick={() => setFilter("pending")}
              height={filter === "pending" ? "70%" : "70%"}
              // backgroundColor={BlackAndWhite.red}
            />
          </div>
        ) : null}
        <div
          style={{
            width: 300,
            // backgroundColor: BlackAndWhite.red,
            minHeight: 50,
            borderTopLeftRadius: 4,
            display: "flex",
            alignItems: "center",
            maxHeight: 50,
            height: 50,
            overflow: "hidden",
            justifyContent: "space-evenly",
            marginRight: 5,
          }}
        >
          {/* <BaseButtons
                mini={true}
                label={"PATIENTS"}
                marginTopFalse={true}
                size={"32.5%"}
                invert={displayTab === "patients" ? false : true}
                onClick={() => setDisplayTab("patients")}
                height={displayTab === "patients" ? "88%" : "88%"}
                // backgroundColor={BlackAndWhite.red}
              /> */}
          <BaseButtons
            mini={true}
            label={"PRESCRIPTIONS"}
            marginTopFalse={true}
            size={"49%"}
            invert={displayTab === "prescriptions" ? false : true}
            onClick={() => {
              setDisplayTab("prescriptions");
              setFilterCheck("prescriptions");
              setFilter("requested");
            }}
            height={displayTab === "prescriptions" ? "88%" : "88%"}
            marginRight={5}
            // backgroundColor={BlackAndWhite.red}
          />
          <BaseButtons
            mini={true}
            label={"SECTION 21'S"}
            marginTopFalse={true}
            size={"49%"}
            invert={displayTab === "section21" ? false : true}
            onClick={() => {
              setDisplayTab("section21");
              setFilterCheck("section21");
              setFilter("pending");
            }}
            height={displayTab === "section21" ? "88%" : "88%"}
            // backgroundColor={BlackAndWhite.red}
          />
        </div>
      </div>
      {/* <PractionerHeader /> */}
      {/* {displaySelected === "invites" ? <div>invite</div> : null} */}
      {displaySelected === "practioners" ? (
        <div
          style={{
            flex: 1,

            width: "100%",
            display: "flex",
          }}
        >
          <div
            style={{
              flex: 0.5,
              borderStyle: "solid",
              height: "99%",
              display: "flex",
            }}
          >
            Practioners information
          </div>
          <div
            style={{
              flex: 0.5,
              // borderStyle: "solid",
              height: "99%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            Practioners
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default PractionerTab;
